import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  ssnAIS: any;
  guidAIS: any;
  cserviceObj: any;
  setScrollTimeout: any; // Timeout used for scroll event
  formURIName: string;
  productName: string;
  lcn: string;
  defaultLanding: string;
  enableFormotiv: any;
  clarifyQuestionFlag: boolean;
  homeOfficeView: boolean;
  contractState: string;
  medPart: string;
  teleapp: boolean;

  constructor() { 
    //empty constructor
  }

  setSSNAIS(value) {
    this.ssnAIS = value;
  }

  getSSNAIS() {
    return this.ssnAIS;
  }

  setGUIDAIS(value) {
    this.guidAIS = value;
  }

  getGUIDAIS() {
    return this.guidAIS;
  }
  setCserviceObj(value) {
    this.cserviceObj = value;
  }

  getCserviceObj() {
    return this.cserviceObj;
  }

  setFormURIName(val: string) {
    this.formURIName = val;
  }

  getFormURIName() {
    return this.formURIName;
  }

  setProdName(val: string) {
    this.productName = val;
  }

  getProdName() {
    return this.productName;
  }

  setLCN(val: string) {
    this.lcn = val;
  }

  getLCN() {
    return this.lcn;
  }

  setDefaultLanding(value: string) {
    this.defaultLanding = value;
  }

  getDefaultLanding() {
    return this.defaultLanding;
  }

  getEnableFormotive() {
    return this.enableFormotiv;
  }

  setHomeOfficeView(value: boolean) {
    this.homeOfficeView = value;
  }

  getHomeOfficeView() {
    return this.homeOfficeView;
  }

  setEnableFormotive(value) {
    this.enableFormotiv = value;
  }

  getClarifyQuestions() {
    return this.clarifyQuestionFlag;
  }

  setClarifyQuestions(value) {
    this.clarifyQuestionFlag = value;
  }

  getContractState() {
    return this.contractState;
  }

  setContractState(value) {
    this.contractState = value;
  }

  getMedPart() {
    return this.medPart;
  }

  setMedPart(value) {
    this.medPart = value;
  }

  getTeleapp() {
    return this.teleapp;
  }

  setTeleapp(value) {
    this.teleapp = value;
  }

  isCA() {
    return this.contractState === 'CA';
  }


  isPart2AndCA() {
    return this.contractState === 'CA' && this.medPart === 'PartII';
  }

  isPart3AndCA() {
    return this.contractState === 'CA' && this.medPart === 'PartIII';
  }

  isNonPart2AndCA() {
    return this.contractState === 'CA' && this.medPart !== 'PartII';
  }

  isNonCAAndPart2() {
    return this.contractState !== 'CA' && this.medPart === 'PartII';
  }

  isCQCA() {
    return this.contractState === 'CA' && this.medPart === 'CQ';
  }


  // Scroll Position
  windowScrollTo(yScrollPos) {
    if (this.setScrollTimeout !== null) {
      clearTimeout(this.setScrollTimeout);
    }
    this.setScrollTimeout = setTimeout(() => {
      window.scrollTo(0, yScrollPos);
    }, 0);
  }

}
